import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type RestrictionType =
  | "feature"
  | "resource"
  | "feature_quota"
  | "ai_credits"
  | null;

export type FeatureQuotaData = {
  feature: string;
  scope: string | null;
  limit: number;
  used: number;
  resetsAt: string | null;
};

export type AiCreditsData = {
  scope: string | null;
  resetsAt: string | null;
};

export type AccessControlState = {
  type: RestrictionType;
  code: string | null;
  quotaData: FeatureQuotaData | null;
  creditsData: AiCreditsData | null;
};

const initialState: AccessControlState = {
  type: null,
  code: null,
  quotaData: null,
  creditsData: null,
};

const accessControlSlice = createSlice({
  name: "accessControl",
  initialState,
  reducers: {
    showFeatureRestrictionPopup: (state, action: PayloadAction<string>) => {
      state.type = "feature";
      state.code = action.payload;
      state.quotaData = null;
      state.creditsData = null;
    },
    showResourceRestrictionPopup: (state, action: PayloadAction<string>) => {
      state.type = "resource";
      state.code = action.payload;
      state.quotaData = null;
      state.creditsData = null;
    },
    showFeatureQuotaRestrictionPopup: (state, action: PayloadAction<FeatureQuotaData>) => {
      state.type = "feature_quota";
      state.code = action.payload.feature;
      state.quotaData = action.payload;
      state.creditsData = null;
    },
    showAiCreditsRestrictionPopup: (state, action: PayloadAction<AiCreditsData>) => {
      state.type = "ai_credits";
      state.code = "credit_balance_exceeded";
      state.quotaData = null;
      state.creditsData = action.payload;
    },
    hideRestrictionPopup: (state) => {
      state.type = null;
      state.code = null;
      state.quotaData = null;
      state.creditsData = null;
    },
  },
});

export const {
  showFeatureRestrictionPopup,
  showResourceRestrictionPopup,
  showFeatureQuotaRestrictionPopup,
  showAiCreditsRestrictionPopup,
  hideRestrictionPopup,
} = accessControlSlice.actions;

export default accessControlSlice.reducer;
